module.exports = __webpack_public_path__ + "static/media/proaa.54cac444.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/explore/roraima/proaa.jpg
// module id = 119
// module chunks = 0